import {
	apis
} from '@/utils/api.js';
export const userStore = defineStore('user', {
	/**
	 * stepData
	 * 数组，哪几页资料没填写，  11-15  分别标识第一页到第五页数据, 示例 [11,12] ,表示填写了第一页和第二页资料没填， 第三到第五页填了
	 */
	state: () => ({
		userData: {
			step: uni.getStorageSync('userData').step || 0,
		},
		token: '',
		stepData: new Map([
			[0, false],
			[1, false],
			[2, false],
		]),
		stepInfo: {},
		contact2: false,
		usersms: false,
		app: false,
		calendar: false,
		device: false,
		usercall: false,
		againReuestcontact2: 0,
		againReuestusersms: 0,
		againReuestapp: 0,
		againReuestcalendar: 0,
		againReuestcall: 0,
		contact2Data: [],
		usersmsData: [],
		calendarData: [],
		appData: [],
		callData: [],
		initTime: Math.round(new Date().getTime() / 1000),
		status: '',
		readyloan: false,
		repaycountus: false,//是否已完件
		uploadhShow: false,//是否点击上传还款凭证
		LibraryShow: false ,//是否已获取用户个人身份信息
		curpNew: '',//新的curp
		selfieShow: false ,//验证码通过  是否重新自拍
		repaycount: 0,
		reserveemailshow: false,
		showPop20Bool: false,
		orderno: '',
		regulationInfo: {},//监管时期存储的身份证信息
		regulationzipai: '',//监管时期存储的自拍照
		isNeedHide: true//是否显示上传账单的入口 true-不显示 false-显示
	}),
	actions: {
		resetData() {
			this.userData = {}
			this.token = ''
			this.stepData.set(0, false)
			this.stepData.set(1, false)
			this.stepData.set(2, false)
			this.repaycountus = false
			this.contact2 = false
			this.usersms = false
			this.app = false
			this.calendar = false
			this.device = false
			this.usercall = false
			this.againReuestcontact2 = 0
			this.againReuestusersms = 0
			this.againReuestapp = 0
			this.againReuestcalendar = 0
			this.againReuestcall = 0
			this.contact2Data = []
			this.usersmsData = []
			this.calendarData = []
			this.appData = []
			this.callData = []
			this.showPop20Bool = false
			this.orderno = ''
			this.regulationInfo = {}
			this.regulationzipai = ''
			this.isNeedHide = true
			uni.removeStorageSync('userData')
			uni.removeStorageSync('token')
			uni.removeStorageSync('currentDayIndex')
			uni.removeStorageSync('loanMoney')
			uni.removeStorageSync('contact2_data')
			uni.removeStorageSync('app_data')
			uni.removeStorageSync('calendar_data')
			uni.removeStorageSync('usersms_data')
			uni.removeStorageSync('mobile')
			uni.removeStorageSync('front') //删除缓存在本地的正面照
			uni.removeStorageSync('obverse')  //删除缓存在本地的反面照
			uni.removeStorageSync('zipai')  //删除缓存在本地的自拍照
			uni.removeStorageSync('bankObj')  //删除缓存在本地的银行卡名称
			uni.removeStorageSync('bankNumber')  //删除缓存在本地的银行卡号
			uni.removeStorageSync('bankTime')  //删除缓存在本地的银行卡有效期
			uni.removeStorageSync('name')  //删除缓存在本地的银行卡持卡人姓名
			uni.removeStorageSync('bankCVC')  //删除缓存在本地的银行卡cvc
			uni.removeStorageSync('curp')
			uni.removeStorageSync('backendObj')
			uni.removeStorageSync('isSync')
			uni.removeStorageSync('infosta')
			uni.removeStorageSync('statusShow')
			uni.removeStorageSync('source')
			uni.removeStorageSync('sourceclick')
			uni.removeStorageSync('location_data')
			uni.removeStorageSync('frontold')
			uni.removeStorageSync('obverseold')
			uni.removeStorageSync('email')
			uni.removeStorageSync('lead')
			uni.removeStorageSync('codeidbtnshow')
			uni.removeStorageSync('selfieShow')
			uni.removeStorageSync('email')
			uni.removeStorageSync('agreeShow')
			uni.removeStorageSync('onHidetime')
			uni.removeStorageSync('onHidetimesshow')
			uni.removeStorageSync('isCanReplace')
			uni.removeStorageSync('refzipai')
			uni.removeStorageSync('repaycountref')
			uni.removeStorageSync('orderStatus')
			uni.removeStorageSync('conzip')
			uni.removeStorageSync('orderNo')
			uni.removeStorageSync('holderNumber')
			uni.removeStorageSync('agreeShowTwo')
			uni.removeStorageSync('repayInfoObj')
			uni.removeStorageSync('FlowSessionId')
			this.initTime = Math.round(new Date().getTime() / 1000)
		},
		setUserData(data) {
			this.userData = data;
			this.token = data.token;
			uni.setStorageSync('userData', data)
			uni.setStorageSync('token', data.token)
		},
		initUserData(key = "userStepData") {
			return new Promise((resolve, reject) => {
				if (uni.getStorageSync('token')) {
					this.token = uni.getStorageSync('token')
					let userData = uni.getStorageSync('userData') || this.userData
					this.userData = userData
					// 设置用户填写了那几页资料
					apis.user[key]().then(res => {
						let [err, sData] = res
						if (err) {
							resolve(true)
						}
						let {
							data,
							msg
						} = sData;
						userData.step = data.step
						this.userData = userData
						uni.setStorageSync('userData', userData)
						let info = data.info
						this.stepInfo = info
						// 第一页
						if (info.email != null) {
							this.stepData.set(0, true)
						} else {
							this.stepData.set(0, false)
						}
						// 第二页
						if (info.relatives_1_name != null && info.relatives_1_phone != null) {
							this.stepData.set(1, true)
						} else {
							this.stepData.set(1, false)
						}
						// 第三页
						if (info.idphoto_1 && info.idphoto_2 && info.headphoto) {
							this.stepData.set(2, true)
						} else {
							this.stepData.set(2, false)
						}
						resolve(true)
					})
				} else {
					resolve(true)
				}
			})
		},
		setStepData(num) {
			this.stepData.set(num, true)
			let step = 0;
			if(this.reserveemailshow){
				step = 1;
			}else{
				step = 0;
			}
			for (var i = 0; i < this.stepData.size; i++) {
				if (this.stepData.get(i)) {
					step = step + 1;
				}
			}
			if (step == 3) {
				this.userData.step = '100'
			}
			uni.setStorageSync('userData', this.userData)
		}

	},
});
